exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "figure {\r\n    margin: 0;\r\n    border: 1px solid #000;\r\n    position: relative;\r\n}\r\n\r\nfigcaption {\r\n    background-color: #F73859;\r\n    color: #fff;\r\n    font-size: 1.2em;\r\n    padding: 10px;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n\r\nimg {\r\n    display: block;\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n:host {\r\n    padding: 1em;\r\n    display: block;\r\n}\r\n\r\n.actions {\r\n    padding: 1em 0;\r\n}\r\n\r\n.comments-btn {\r\n    background-color: #404B69;\r\n    color: #DBEDF3;\r\n    padding: 1em;\r\n    border-style: none;\r\n}\r\n\r\n.like-btn {\r\n    color: white;\r\n    font-size: 1.2rem;\r\n    background-color: #283149;\r\n    border: none;\r\n    padding: .5em\r\n}\r\n\r\n.liked {\r\n    color: #F73859;\r\n}\r\n\r\n.comments {\r\n    background-color: #DBEDF3;\r\n    color: black;\r\n    padding: .5em;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Aimee/Desktop/git/Angular/aimees-photo-blog/src/app/components/entries/entry/entry.component.css
// module id = ../../../../../src/app/components/entries/entry/entry.component.css
// module chunks = main